<template>
  <div class="flex-grow-1">
    <div v-if="showPreview" class="preview p-2 shadow-lg rounded mb-3">
      <h5 class="m-0">
        <a :href="urlLink">
          {{ slicedTitle }}{{ overflowedTitle ? "..." : "" }}
        </a>
      </h5>
      <div v-if="encodedUrl">
        <a :href="urlLink">
          {{ urlLink }}
        </a>
      </div>
      <p class="m-0">
        {{ slicedDescription }}{{ overflowedDescription ? "..." : "" }}
      </p>
    </div>

    <div v-if="hasTitle">
      <FormInput
        :value="title"
        @input="val => $emit('update:title', val)"

        class="sm form-element mt-4"
        :ske="true"
        :warning="overflowedTitle"

        id="title"
        label="SEO-title"
      />
      <div class="label d-flex justify-content-end" :class="overflowedTitle && 'text-warning'" style="font-style: italic;">
        {{ title.length || 0 }}/{{titleMax}} tekens (advies)
      </div>
    </div>
    <div v-if="hasDescription">
      <FormTextarea
        :value="description"
        @input="val => $emit('update:description', val)"

        class="sm form-element"
        :ske="true"
        :warning="overflowedDescription"

        id="description"
        label="SEO-beschrijving"
      />
      <div class="label d-flex justify-content-end" :class="overflowedDescription && 'text-warning'" style="font-style: italic;">
        {{ description.length || 0 }}/{{descriptionMax}} tekens (advies)
      </div>
    </div>
    <div v-if="hasUrl" class="update_url">
      <FormInput
        :value="url"
        @input="val => $emit('update:url', val)"

        class="sm form-element form-url url_gen mr-3"
        :ske="true"

        id="url"
        label="SEO-URL"
      />
      <slot name="url-tip"></slot>
      <div class="update_url_button">
        <button>Refresh URL</button>
      </div>
    </div>
  </div>
</template>

<script>

import FormInput from "../components/Inputs/FormInput.vue"
import FormTextarea from "../components/Inputs/FormTextarea.vue"


export default {
  components: {
    FormInput,
    FormTextarea
  },
  props: {
    description: String,
    title: String,
    url: String,
    initialProductWebsites: {
      type: Array,
      required: false,
    },
    initialProduct: {
      type: Object,
      required: false,
    },

    hasUrl: {
      type: Boolean,
      default: true,
    },
    hasTitle: {
      type: Boolean,
      default: true,
    },
    hasDescription: {
      type: Boolean,
      default: true,
    },

    descriptionMax: {
      type: Number,
      default: 160,
    },
    titleMax: {
      type: Number,
      default: 70,
    },
  },
  data() {
    return {
      productWebsites: [],
    };
  },
  created() {
    this.loadProduct()
  },
  methods: {
    async loadWebsiteProducten({ websites }) {
      if (!this.initialProductWebsites) {
        this.productWebsites = await Promise.all(
          websites.map(async uid => {
            return (await this.axios.get(`/api/websites/${uid}`)).data
          })
        )
      } else {
        this.productWebsites = this.initialProductWebsites
      }
    },
    async loadProduct() {
      if (!this.$route.params.id) return;
      const product = this.initialProduct ? this.initialProduct : (await this.axios.get(`/api/products/${this.$route.params.id}`)).data
      if (product) {
        this.loadWebsiteProducten(product)
      }
    }
  },
  computed: {
    urlLink() {
      if(this.productWebsites.length) {
        return `https://${this.productWebsites[0].domainname}/${this.encodedUrl}.html`
      } else {
        return `https://example.com/${this.encodedUrl}.html`
      }
    },
    showPreview() {
      return (this.title && this.title.length) ||
            (this.description && this.description.length) ||
            (this.url && this.url.length)
    },
    slicedDescription() {
      return this.description && this.description.slice(0, this.descriptionMax)
    },
    slicedTitle() {
      return this.title && this.title.slice(0, this.titleMax)
    },
    encodedUrl() {
      const str = this.url
      return str && encodeURIComponent(str.toLowerCase().replace(/ /g, '-'))
    },

    overflowedTitle() {
      return this.title && this.title.length > this.titleMax
    },
    overflowedDescription() {
      return this.description && this.description.length > this.descriptionMax
    },
  },
  watch: {
    initialProductWebsites() {
      this.productWebsites = this.initialProductWebsites
    },
  },
}

</script>

<style scoped>

.form-url {
  margin-bottom: 0px;
}

h5 a {
  font-size: 20px;
  /* color: #141AA4; */
  color: #1024a0;
  font-weight: 550;
}

h5 a:hover {
  text-decoration: underline;
}

.preview {
  word-break: break-all;
  word-wrap: break-word;
  border: 1px solid #e7e7e7;
  padding: 0 20px;
}


.preview div a{
  color: #2A642A;
}

.preview p {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  max-width: 800px;
}

.label {
  margin-top: -15px;
}

.update_url {
  display: flex;
  align-items: flex-end;
}

.url_gen {
  flex: 1;
}

.update_url_button {
  width: 110px;
  height: 33px;
}

.update_url_button :hover {
  opacity: 0.8;
  transition: 0.5s;
}

.update_url_button button {
  padding: 1px 9px;
  width: 100%;
  height: 100%;
  background: #A7A9AB;
  color: white;
  font-weight: 400;
  font-size: 12px;
  line-height: 26px;
  font-family: 'Inter';
}
</style>
